import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d241f77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-select" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Advanced product", -1))
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "product-name" }
const _hoisted_5 = {
  key: 1,
  class: "product-select__dropdown"
}
const _hoisted_6 = {
  class: "product-select__list",
  role: "listbox"
}
const _hoisted_7 = ["aria-setsize", "aria-posinset", "aria-selected", "title"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "product-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_on_clickaway = _resolveDirective("on-clickaway")!

  return _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_1, [
    _hoisted_2,
    (_ctx.router.currentRoute.value.meta.sidebar !== false)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["product-select__selector", [_ctx.productIconClass(_ctx.selectedProduct()), { 'product-select__selector--expanded': _ctx.isListDisplayed }]]),
          "aria-haspopup": "listbox",
          role: "button",
          tabindex: "0",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDropdownClick && _ctx.handleDropdownClick(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDropdownClick && _ctx.handleDropdownClick(...args)), ["prevent"]), ["space"])),
          title: `${_ctx.selectedProduct.name}`
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedProduct().displayname), 1)
        ], 42, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.isListDisplayed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MfProducts, (MfProduct, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: MfProduct.name,
                class: "product-select__item",
                "aria-setsize": _ctx.MfProducts.length,
                "aria-posinset": index + 1,
                "aria-selected": MfProduct.selected ? 'true' : undefined,
                title: `${MfProduct.name}`,
                role: "option"
              }, [
                _createElementVNode("a", {
                  href: MfProduct.uri,
                  class: _normalizeClass(_ctx.productIconClass(MfProduct))
                }, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(MfProduct.name), 1)
                ], 10, _hoisted_8)
              ], 8, _hoisted_7))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_on_clickaway, _ctx.closeDropdown]
  ])
}